import { Component, OnInit, TemplateRef } from '@angular/core';
import { LoadService } from '../../services/load.service';
import { OrdensalidaService} from '../../services/ordensalida.service';
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { StockService } from '../../services/stock.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ActivatedRoute } from '@angular/router';
import {Router} from '@angular/router';
import { FilterUrlService } from '../../services/filter-url.service';
import { ProductsService } from '../../services/products.service';
import { TagsService } from '../../services/tags.service';
import { Tags } from '../../model/Tags';
import * as moment from 'moment';


@Component({
  selector: 'app-revisionorder',
  templateUrl: './revisionorder.component.html',
  styleUrls: ['./revisionorder.component.css']
})
export class RevisionorderComponent implements OnInit {
  public orders:any[];
  public order:any;
  public orden_seleccionada:boolean;
  public tagsActuales:any[];
  public tagsNuevos:any[];
  public tagsNuevosHistorial:any[];
  public quitarTags:any[];
  public stock_list:any[];
  public meta:any;
  public links:any;
  public alert:string;
  public isopen:boolean;
  public mostrartabla:boolean;
  public carga_terminada:boolean;
  public modalRef:BsModalRef;
  public modalRef2:BsModalRef;
  public modalRef3:BsModalRef;
  public modalRef4:BsModalRef;
  public grupo_actual:any;
  public grupo_detalle:any;
  public tags_grupo_detalle:any[];
  public formComentario:FormGroup;
  public formDates:FormGroup;
  public filter:string;
  public settings = {
    columns:{
      pr_code: {
        header: "Producto",
        type: "obj",
        filter: { visible:true,  id_type:'number', default:'asc', type:'dd' },
      },
      pr_description:{
        header:"Descripción",
        type:"text",
        filter:{visible:true}
      },
      pr_group:{
        header:"Grupo",
        type:"text",
        filter:{visible:true}
      },
      lot_code: {
        header: "Lote",
        type:"text",
        filter: { visible:true }
      },
      elaboration_date: {
        header: "Fecha Elaboración",
        type:"date",
        filter: { visible:true }
      },
      pallet_code:{
        header:"Pallet",
        type:"text",
        filter:{visible:false}
      },
      location:{
        header:"Ubicación",
        type:"text",
        filter:{visible:false}
      },
      position:{
        header:"Posición",
        type:"text",
        filter:{visible:false}
      },
      total_box:{
        header:"Total Cajas",
        type:"obj",
        tipo:"total",
        path:"relationships.tags.data.length",
        filter:{default:'asc'}
      }
    },
    actions:{
      edit: false,
      view: false,
      delete: false,
      close:false,
      detail:true,
    }
  };

  constructor(private _loaddata:LoadService,private _productsService:ProductsService, private ordenSalida:OrdensalidaService, private _stockService:StockService, private bsModalService:BsModalService, private _bsModalService:BsModalService, private _tagsService:TagsService, private _filterUrlService:FilterUrlService) {
    this.orders = [];
    this.orden_seleccionada = false;
    this.carga_terminada = false;
    this.alert = '';
    this.isopen = false;
    this.tagsActuales = [];
    this.stock_list = [];
    this.mostrartabla = false;
    this.grupo_actual = {};
    this.grupo_detalle = {};
    this.tagsNuevos = [];
    this.tagsNuevosHistorial = [];
    this.quitarTags = [];
    this.tags_grupo_detalle = [];
    this.formDates = new FormGroup({
      'inicio_date':new FormControl('',Validators.required),
      'termino_date':new FormControl('',Validators.required)
    });
    this._filterUrlService.changeFilters("");
   }

  ngOnInit() {
    this._filterUrlService.filters.subscribe(new_filter => this.filter = new_filter );
    this.loadOrders();
    this.formComentario = new FormGroup({
      'comentario': new FormControl('',Validators.required)
    });
  }

  loadOrders(){
    this.carga_terminada = false;
    this.alert = 'Cargando Ordenes por Revisar...';
    this.isopen = true;
    this._loaddata.loadChange(40);
    this.ordenSalida.getRevisionOrders().subscribe((response:any)=>{
      console.log("Ordenes Por Revisar: ",response);
      this.carga_terminada = true;
      this.orders = response.data;
      this.alert = 'Ordenes Cargadas.';
      this.isopen = true;
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();
    },error=>{
      console.log("No se han cargado las ordenes por revisar", error.error.error);
    })
  }

  verOrden(orden:any){
    this.orden_seleccionada = true;
    this.alert = 'Cargando Orden...';
    this.isopen = true;
    this._loaddata.loadChange(20);
    this.ordenSalida.getOne(orden.id).subscribe((response:any)=>{
      this.order = response;
        this.ordenSalida.getTagsOrder(this.order.id).subscribe((response:any)=>{
          this.tagsActuales = response.data;
          console.log("TAGS DE ORDEN: ", response);
        },error=>{
          console.log("No se han podido obtener las cajas asociadas a la orden", error.error.error);
        });
        console.log("ORDEN: ", this.order);
        this.alert = 'Orden Cargada.';
        this.isopen = true;
        this._loaddata.loadChange(40);
        this.loadProductos();



    },error=>{
      this.volver();
      console.log("ERROR: ", error.error.error);
    });
  }

  loadProductos(){
    this.alert = 'Cargando Productos...';
    this.isopen = true;
    this._loaddata.loadChange(40);

    this._productsService.getAll().subscribe(
      (response:any) => {
        let data = response.data;
        //console.log("DATA: ",data);
        let products:string = "{";
        for (var key in data) {
          //console.log("KEY: ", key);
          if (data.hasOwnProperty(key)) {
            products+='"'+data[key].attributes.code+'":"'+data[key].attributes.code+'",';
          }
        }
        products = products.slice(0,-1);
        products+="}";
        this.settings.columns.pr_code.filter['data'] = products;
        this.alert = "Productos Cargados.";
        this.isopen = true;
        this.mostrartabla = true;
        this._loaddata.loadChange(100);
        //this.loadStock();
      },
      (error) => {
        console.log("Error: ", error.error.error);
      }
    );
  }

  loadStock(){
    this.alert = 'Cargando Stock Disponible...';
    this.isopen = true;
    this._loaddata.loadChange(60);
    this._stockService.getStockSummary().subscribe((response:any)=>{
      this.stock_list = response.data;
      this.meta = response.meta;
      this.links = response.links;
      console.log(this.stock_list, this.meta, this.links);
      this.alert = 'Stock Disponible Cargado.';
      this.isopen = true;
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();
    },error=>{
      console.log("ERROR AL CARGAR STOCK: ", error.error.error);
    })
  }

  volver(){
    this.orden_seleccionada = false;
    this.orders = [];
    this.alert = '';
    this.isopen = false;
    this.tagsActuales = [];
    this.stock_list = [];
    this.mostrartabla = false;
    this.grupo_actual = {};
    this.grupo_detalle = {};
    this.tagsNuevos = [];
    this.tagsNuevosHistorial = [];
    this.quitarTags = [];
    this.tags_grupo_detalle = [];
    this.loadOrders();
  }

  /*busca los datos con respecto a los filtros seleccinados*/
  loadDataFiltered(filters){
    this.actualizarFiltroConFechas(filters);
    console.log('FILTROS: ', this.filter);
    let filter = `${this.filter}&enabled=1`;
    this.alert = 'Buscando Resultados...'
    this.isopen = true;
    this._loaddata.loadChange(40);
    this._stockService.getDataFiltered(this.filter).subscribe(
      (response:any) => {
        console.log("Respuesta del filtro a ver si es esta", response);
        this.stock_list = response.data;
        // for(let c of this.stock_list){
        //   c.attributes.select = false;
        // }
        // this.stock_list = this.formatDate(this.stock_list);
        this.links = response.links;
        this.meta = response.meta;

        this._loaddata.loadChange(100);
        this.alert = "Carga Correcta."
        this.isopen =true;
        this.onClosedAutomatic();
      },
      (error) => {
        if(error.status == 0){
          this.alert = 'Busqueda sin resultados.';
          this.onClosedAutomatic();
        }
        else{
          console.log("ERROR: ",error.error.error);
        }
      }
    );
  }

  actualizarFiltroConFechas(filters){
    console.log("filtro recibido",filters);
    let filtro_nuevo = ``;
    let from = this.formDates.get('inicio_date').value;
    let to = this.formDates.get('termino_date').value;
    let f = moment(from).format("YYYY-MM-DD");
    let t = moment(to).format("YYYY-MM-DD");
    //console.log("From: ",from);
    //console.log("To: ",to);

    if(filters.length > 0){
      /*si el filtro ya contiene parametros*/
      let contain_symbol  = filters.includes('?from=');
      let contain_griega = filters.includes('&from=');
      if(contain_symbol){
        /*si contiene el simbolo de interrogación seguido del from (quiere decir que no hay ningun filtro mas que las fechas)*/
        if(!filters.includes('&enabled=1')){
          filtro_nuevo = `?from=${f}&to=${t}&enabled=1`;
        }
        else{
          filtro_nuevo = `?from=${f}&to=${t}`;
        }

        this._filterUrlService.changeFilters(filtro_nuevo);
        console.log("FILTRO SOLO CON FECHAS:",this.filter);
      }
      else if(contain_griega){
        /*si ya contiene un rango de fechas*/
        console.log("SI AQUI");
        /*separando el &from*/
        let array_from = filters.split("&from=");
        let parte_1 = array_from[0];
        let fin_parte_2 = array_from[1].length;
        let parte_2 = array_from[1].slice(10,fin_parte_2);

        let filtro_from_actualizado = `${parte_1}&from=${f+parte_2}`;
        console.log("filtro from actualizado:",filtro_from_actualizado);
        /*separando el &to*/
        let array_to = filtro_from_actualizado.split("&to=");
        let parte_1_final = array_to[0];
        let fin_parte_2_final = array_to[1].length;
        let parte_2_final = array_to[1].slice(10,fin_parte_2_final);
        if(!filters.includes('&enabled=1')){
            filtro_nuevo = `${parte_1_final}&to=${t+parte_2_final}&enabled=1`;
        }
        else{
          filtro_nuevo = `${parte_1_final}&to=${t+parte_2_final}`;
        }

        this._filterUrlService.changeFilters(filtro_nuevo);
        console.log("FECHAS ACTUALIZADAS PLEASE :'( ",this.filter);

      }
      else{
        /*no contiene un rango de fechas pero si tiene filtros aplicados*/
        if(f != 'Invalid date' && t != 'Invalid date'){

          if(!filters.includes('&enabled=1')){
            filtro_nuevo = `${filters}&from=${f}&to=${t}&enabled=1`;
          }
          else{
            filtro_nuevo = `${filters}&from=${f}&to=${t}`;
          }

          this._filterUrlService.changeFilters(filtro_nuevo);
          console.log("FILTRO NO TIENE RANGO FECHAS PERO SI FILTROS:",this.filter);
        }
        else{
          if(!filters.includes('&enabled=1')){
            filtro_nuevo = `${filters}&enabled=1`;
            this._filterUrlService.changeFilters(filtro_nuevo);
            console.log("FILTRO CUANDO NO HAY RANGO DE FECHAS",this.filter);
          }
        }

      }
    }
    else{
      /*el filtro no contiene parametros*/

      if(!filters.includes('&enabled=1')){
        filtro_nuevo = `?from=${f}&to=${t}&enabled=1`;
      }
      else{
        filtro_nuevo = `?from=${f}&to=${t}`;
      }

      this._filterUrlService.changeFilters(filtro_nuevo);
      console.log("FILTRO VACIO:",this.filter);
    }
  }

  public filtrarFecha(){
    this.loadDataFiltered(this.filter);
  }

  updateData(response:any){
    console.log("Respuesta Actualización: ", response);
    this.stock_list = response.data;
    this.meta = response.meta;
    this.links = response.links;
  }

  mostrarDetalle(grupo:any,template: TemplateRef<any>){
    this.grupo_actual = grupo;
    console.log("Grupo seleccionado: ", this.grupo_actual);
    for(let tag of this.grupo_actual.relationships.tags.data){
      for(let item of this.tagsNuevosHistorial){
        if(item.tag_id === tag.id){
          console.log("Entro");
          tag.attributes.added = true;
        }
      }
    }
    this.modalRef = this._bsModalService.show(template);
  }

  cerrarModal(){
    this.modalRef.hide();
    //this.grupo_actual = {};
  }

  agregarTag(tag_id:number, index:number){
    console.log("Tag_id: ", tag_id);
    this.tagsNuevos.push({
      'tag_id':tag_id
    });
    this.tagsNuevosHistorial.push({
      'tag_id':tag_id
    });
    // for(let tag of this.grupo_actual.relationships.tags.data){
    //   for(let item of this.tagsNuevosHistorial){
    //     if(item.tag_id === tag.id){
    //       console.log("Entro");
    //       tag.attributes.added = true;
    //     }
    //   }
    // }

    let tag = new Tags(0,0,0,0,0,0,0,0,0,0,0,0,0,0);
    let body = tag.getJsonOrdenSalida(this.tagsNuevos, this.order.id);
    console.log("Body: ", body);
    this._tagsService.update(body).subscribe((response:any)=>{
      this.tagsNuevos = [];
      console.log("respuesta tags agregados", response);
      this.grupo_actual.relationships.tags.data.splice(index,1);
      if(this.grupo_actual.relationships.tags.data.length == 0){
        this.cerrarModal();
        let index = this.grupo_actual.index;
        this.stock_list.splice(index,1);
      }
      this.ordenSalida.getTagsOrder(this.order.id).subscribe((response:any)=>{
        this.tagsActuales = response.data;
        console.log("TAGS DE ORDEN: ", response);
      },error=>{
        console.log("No se han podido obtener las cajas asociadas a la orden", error.error.error);
      });

    },error=>{
      console.log("No se han agregado los tags a la orden", error.error.error);
    });
  }

  agregarTodos(){
    for(let tag of this.grupo_actual.relationships.tags.data){

      this.tagsNuevos.push({
           'tag_id':tag.id
      });
    }



    if(this.tagsNuevos.length > 0){
      let tag = new Tags(0,0,0,0,0,0,0,0,0,0,0,0,0,0);
      let body = tag.getJsonOrdenSalida(this.tagsNuevos, this.order.id);
      console.log("Body: ", body);
      this._tagsService.update(body).subscribe((response:any)=>{
        console.log("respuesta tags agregados", response);
        this.cerrarModal();
        let index = this.grupo_actual.index;
        this.stock_list.splice(index,1);
        this.ordenSalida.getTagsOrder(this.order.id).subscribe((response:any)=>{
        this.tagsActuales = response.data;
          console.log("TAGS DE ORDEN: ", response);
        },error=>{
          console.log("No se han podido obtener las cajas asociadas a la orden", error.error.error);
        });

      },error=>{
        console.log("No se han agregado los tags a la orden", error.error.error);
      });
    }

  }

  detalleGrupo(grupo:any,template2: TemplateRef<any>){
    console.log("GRUPO: ", grupo.relationships.tags.data.length);
    this.grupo_detalle = grupo;
    this.tags_grupo_detalle = grupo.relationships.tags.data;
    console.log("GRUPO DETALLE: ", this.grupo_detalle);
    this.modalRef2 = this._bsModalService.show(template2);
  }

  cerrarModal2(){
    this.modalRef2.hide();
    //this.grupo_actual = {};
  }

  onClosedAutomatic(){
    setTimeout(()=>{
      this.isopen = false;
      this.alert = '';
    },3000)
  }

  onClosed(){
    this.isopen = false;
  }

  quitarTag(tag_id, index:number){
    let tag = {
      'tag_id':tag_id
    }



    this.quitarTags.push(tag);
    let t = new Tags(0,0,0,0,0,0,0,0,0,0,0,0,0,0);
    let body = t.getJsonOrdenSalidaQuitar(this.quitarTags);
    this._tagsService.update(body).subscribe((response:any)=>{
      console.log("Respuesta quitar tag", response);
      this.quitarTags = [];
      this.grupo_detalle.relationships.tags.data.splice(index,1);
      if(this.grupo_detalle.relationships.tags.data.length == 0){
        this.cerrarModal2();
      }
      this.ordenSalida.getTagsOrder(this.order.id).subscribe((response:any)=>{
      this.tagsActuales = response.data;
      },error=>{
        console.log("No se ha podido cargar la orden después de quitar el tag");
      })
    },error=>{
      console.log("No se ha podido quitar el Tag", error.error.error);
    });
  }

  quitarTodos(grupo:any){
    this.alert = 'Quitando las Cajas de la Orden...';
    this.isopen = true;
    this._loaddata.loadChange(20);
    for(let ta of this.grupo_detalle.relationships.tags.data){
      let tag = {
        'tag_id':ta.id
      }
      this.quitarTags.push(tag);
    }

   let t = new Tags(0,0,0,0,0,0,0,0,0,0,0,0,0,0);
   let body = t.getJsonOrdenSalidaQuitar(this.quitarTags);

   this._tagsService.update(body).subscribe((response:any)=>{
     console.log("Respuesta quitar tag", response);
     this.alert = 'Cajas Quitadas...';
     this.isopen = true;
     this._loaddata.loadChange(40);
     this.quitarTags = [];
     this.ordenSalida.getTagsOrder(this.order.id).subscribe((response:any)=>{
       this.alert = 'Cajas de orden Actualizada.';
       this.isopen = true;
       this._loaddata.loadChange(100);
       this.onClosedAutomatic();
       this.tagsActuales = response.data;
       this.cerrarModal2();
     },error=>{
       console.log("No se ha podido cargar la orden después de quitar el tag");
     });
   },error=>{
     console.log("No se ha podido quitar el Tag", error.error.error);
   });
  }

  mostrarModalComentario(template: TemplateRef<any>){
    this.modalRef3 = this.bsModalService.show(template);
  }

  cerrarModalComentario(){
    this.modalRef3.hide();
  }

  agregarComentario(){
    let comentario = this.formComentario.get('comentario').value;
    this.alert = 'Agregando Comentario...';
    this.isopen = true;
    this._loaddata.loadChange(40);
    //console.log("COmentario: ", comentario);
    let body = this.ordenSalida.transformDataCommentaryOrder(comentario);
    console.log("Body: ", body);
    console.log("ID: ",this.order.id);
    this.ordenSalida.addCommentaryOrder(body,this.order.id).subscribe((response:any)=>{
      this.alert = 'Comentario Agregado.';
      this.isopen = true;
      this._loaddata.loadChange(100);
      this.cerrarModalComentario();
      this.limpiarFormulario();
      this.onClosedAutomatic();
      console.log("respuesta comentario: ", response);
      this.order.relationships.messages = response.relationships.messages;
    },error=>{
      console.log("No se ha agregado el comentario", error.error.error);
    })
  }

  limpiarFormulario(){
    this.formComentario.reset();
    this.formComentario.setValue({
      'comentario':''
    });
  }

  mostrarConfirmarPreAprobar(template:TemplateRef<any>){
    this.modalRef4 = this._bsModalService.show(template);
  }

  cerrarModalPreAprobar(){
    this.modalRef4.hide();
  }

  preAprobarConfirmar(){
    this.alert = 'Pre Aprobando Orden...';
    this.isopen = true;
    this._loaddata.loadChange(40);
    let body = this.ordenSalida.transformDataUpdateStatusToPreApprovated(this.order.id);
    this.ordenSalida.updateStateToPreApprovated(body,this.order.id).subscribe((response:any)=>{
      console.log("respuesta pre aprobación: ", response);
      this.alert = 'Orden Pre Aprobada.';
      this.isopen = true;
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();
      this.cerrarModalPreAprobar();
      this.volver();
    },error=>{
      console.log('No se ha pre aprobado la orden: ', error.error.error);
      this.alert = 'No se ha podido pre aprobar la orden. Error: '+error.error.error;
      this.isopen = true;
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();
    })
  }

  openPDF(){
    console.log("orden",this.order);
    let url = this.order.attributes.pdf_url;
    window.open(url, '_blank');
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/revisionorder/revisionorder.component.ts